import React from 'react';
import { motion } from 'framer-motion';
import { Quote } from 'lucide-react';
const reviews = [{
  name: 'Олена М.',
  text: 'Валентина — справжній професіонал! Вона ідеально підібрала колір, який я так довго шукала. Волосся після фарбування виглядає живим і блискучим.'
}, {
  name: 'Марія К.',
  text: "Пройшла курс 'Колористика з нуля'. Дуже задоволена подачею матеріалу та кількістю практики. Тепер впевнено працюю з клієнтами."
}, {
  name: 'Ірина В.',
  text: "Робила біозавивку. Результат перевершив усі очікування! Локони виглядають дуже природно, а волосся залишилося м'яким."
}];
export function Reviews() {
  return <section className="py-24 bg-gray-50" data-id="element-213">
      <div className="container mx-auto px-6 md:px-12" data-id="element-214">
        <div className="text-center max-w-2xl mx-auto mb-16" data-id="element-215">
          <h2 className="font-heading text-4xl md:text-5xl text-dark mb-4" data-id="element-216">
            Відгуки
          </h2>
          <div className="w-12 h-px bg-accent mx-auto mb-6" data-id="element-217"></div>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-12" data-id="element-218">
          {reviews.map((review, index) => <motion.div key={index} initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.6,
          delay: index * 0.1
        }} className="relative" data-id="element-219">
              <Quote className="text-accent/20 mb-6" size={32} strokeWidth={1} data-id="element-220" />
              <p className="text-gray-600 font-light text-sm leading-relaxed mb-6 relative z-10 italic" data-id="element-221">
                "{review.text}"
              </p>
              <div className="flex items-center" data-id="element-222">
                <div className="w-8 h-px bg-accent mr-4" data-id="element-223"></div>
                <p className="font-heading tracking-wide text-dark text-lg" data-id="element-224">
                  {review.name}
                </p>
              </div>
            </motion.div>)}
        </div>
      </div>
    </section>;
}